import PeripheralBridge from '../utils/peripheralBridge'

/**
 * Call Peripheral Bridge method
 * NOT to be confused with "callHandler" methods
 *
 * @param {String} method PERIPHERAL_BRIDGE_REGISTER_HANDLER_METHODS
 * @param {Object|Null} params
 * @param {Function} callback
 * @param {Boolean} throwError throws error if bridge not initialized
 */
export const callPeripheralBridge = (method, params = null, callback = () => {}, throwError = false) => {
  const bridgeInstance = PeripheralBridge.getBridge()
  if (!bridgeInstance) {
    if (throwError) {
      throw new Error('Peripheral Bridge not initialized')
    }
    return
  }

  bridgeInstance.call(method, params, callback)
}

/**
 * Call Handler Peripheral Bridge method
 * NOT to be confused with "call" methods
 *
 * @param {String} method PERIPHERAL_BRIDGE_CALL_HANDLER_METHODS
 * @param {Object|Null} params
 * @param {Function} callback
 * @param {Boolean} throwError throws error if bridge not initialized
 */
export const callHandlerPeripheralBridge = (method, params = null, callback = () => {}, throwError = false) => {
  const bridgeInstance = PeripheralBridge.getBridge()
  if (!bridgeInstance) {
    if (throwError) {
      throw new Error('Peripheral Bridge not initialized')
    }
    return
  }

  bridgeInstance.callHandler(method, params, callback)
}

/**
 * Register Peripheral Bridge Handler for bridge calls
 *
 * @param {String} method PERIPHERAL_BRIDGE_REGISTER_HANDLER_METHODS
 * @param {Function} callback (data, responseCallback) => {}
 * @param {Boolean} throwError throws error if bridge not initialized
 */
export const registerHandler = (method, callback = () => {}, throwError = false) => {
  const bridgeInstance = PeripheralBridge.getBridge()
  if (!bridgeInstance) {
    if (throwError) {
      throw new Error('Peripheral Bridge not initialized')
    }
    return
  }

  bridgeInstance.registerHandler(method, callback)
}
